// FIXME: remove these as soon as we know for sure they're no longer in use.
(function(){
  nn.handlers.init.BoxSizingFix = function(){};
  nn.component.BorderFix = function(){};
  nn.component.BorderFix.prototype.reflow = function(){};
  nn.component.OddEvenFix = function(){};
})();
